// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $ from "jquery";

const fragments = {
	INPUTS: '.form-group--float-label input',
	TEXTAREAS: '.form-group--float-label textarea',
	DISABLED: '*[disabled]',
	REQUIRED: '*[required], *[data-required]',
};

export default class Form extends WebComponent {
	constructor(props) {
		super(props);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}

	didMount() {
		const {
			preventMultipleSubmit,      // zabrana proti vicenasobnemu odeslani formulare
			submitOnChange,             // provede submit v pripade vyvolani change eventy na komponentach formulare
			turbolinksForm,           // odeslani formulare ajax requestem
		} = this.props;

		if (preventMultipleSubmit !== false || turbolinksForm === true) this.on('submit', this.handleSubmit);
		if (submitOnChange === true) {
			this.inputElements = this.element.querySelectorAll('input:not([type="submit"])');
			this.handleSubmitOnChange();
		}

		this.inputsElement = this.element.querySelectorAll(fragments.INPUTS);
		this.textareasElement = this.element.querySelectorAll(fragments.TEXTAREAS);
		this.disabledElement = this.element.querySelectorAll(fragments.DISABLED);
		this.requiredElement = this.element.querySelectorAll(fragments.REQUIRED);

		// window.addEventListener("load", this.initLabels);
		let _self = this;
		/**
		 * set timeout to make sure esp target content is found and form elements can be reinitiated
		 */
		setTimeout(function(){
			for (let i = 0; i < _self.inputsElement.length; i++) {
				_self.initLabels(_self.inputsElement[i]);
				_self.inputsElement[i].addEventListener('focus', _self.focusHandler);
				_self.inputsElement[i].addEventListener('blur', _self.blurHandler);
				_self.inputsElement[i].addEventListener('input', _self.focusHandler);
			}

			for (let i = 0; i < _self.textareasElement.length; i++) {
				_self.initLabels(_self.textareasElement[i]);
				_self.textareasElement[i].addEventListener('focus', _self.focusHandler);
				_self.textareasElement[i].addEventListener('blur', _self.blurHandler);
			}

			for (let i = 0; i < _self.disabledElement.length; i++) {
				_self.initLabels(_self.disabledElement[i]);
			}
		},200);
	   /**
		* scroll to failed validation element
		**/
		$(this.element).on('validationFailed', function(e) {
			let hasErrorEl = document.querySelectorAll('.has-error');
			if(hasErrorEl[0]){
				window.scrollTo(0, hasErrorEl[0].getBoundingClientRect().top + window.scrollY - 100);
				hasErrorEl.forEach((el) => {
					const helpBlock = el.querySelector('.help-block');
					if(helpBlock) {
						window.dataLayer.push({
							'event': 'form_error',
							'form_error': {
								'url': window.location.href,
								'errortype': helpBlock.innerText,
							},
							_clear: true
						})
					}
				});
			}
		});
	}

	initLabels = (element) => {
		let fG = element.closest('.form-group');
		if (fG) {
			if (element.value === "" && !element.disabled) {
				fG.classList.remove('form-group--label-active');
			} else {
				fG.classList.add('form-group--label-active');
			}
		}
	};

	focusHandler = (e) => {
		let fG = e.target.closest('.form-group');
		if (fG) {
			fG.classList.add('form-group--label-active');
		}
	};

	blurHandler = (e) => {
		let fG = e.target.closest('.form-group');
		if (fG) {
			if (e.target.value === "") {
				fG.classList.remove('form-group--label-active');
			}
		}
	};

	willUnMount() {
		const {
			submitOnChange,
		} = this.props;

		if (submitOnChange === true && this.inputElements) {
			this.inputElements.forEach((inputElement) => {
				inputElement.removeEventListener('change', this.handleChange);
			});
		}
		this.inputElements = null;
	}

	/*
	  Zamezeni pred vicenasobnym odeslanim formulare
	 */
	handleSubmit() {
		const {
			preventMultipleSubmit,      // zabrana proti vicenasobnemu odeslani formulare
			turbolinksForm,           // odeslani formulare ajax requestem
		} = this.props;

		const submitElements = this.element.querySelectorAll('[type="submit"]');

		if (preventMultipleSubmit !== false) {
			setTimeout(() => {
				if (submitElements) {
					submitElements.forEach((submitElement) => {
						submitElement.setAttribute('disabled', 'disabled');
					});
				}
			}, 1)
		}

		if ((turbolinksForm === true) && (typeof(Turbolinks) != 'undefined')) {
			event.preventDefault();

			const xhr = new XMLHttpRequest();
			const formData = new FormData(this.element);
			const requestUrl = this.element.getAttribute('action');

			submitElements.forEach((submitElement) => {
				formData.append(submitElement.name, submitElement.value);
			});

			xhr.onload = () => {
				if (xhr.status == 200) {
					if (xhr.responseURL.indexOf(requestUrl, xhr.responseURL.length - requestUrl.length) == -1) {
						Turbolinks.visit(xhr.responseURL);
					}
					else {
						const res = document.createElement('div');
						res.innerHTML = xhr.responseText;
						this.element.innerHTML = res.querySelector('#' + this.element.id).innerHTML;
					}
				}
			};

			xhr.open(this.element.getAttribute('method'),requestUrl, true);
			xhr.send(formData);
		}
	}

	/*
	  Submit formulare pri zmene
	 */
	handleChange() {
		this.element.submit();
	}

	/*
	  Osetreni submitu formulare pri zmene inputu
	 */
	handleSubmitOnChange() {
		if (this.inputElements) {
			this.inputElements.forEach((inputElement) => {
				inputElement.addEventListener('change', this.handleChange);
			});
		}
	}
}




// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Form.js